module.exports = __webpack_public_path__ + "img/horizontal_3_1_8004.43319f1b.png";